'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reduxFormSubmitActions = require('actions/reduxFormSubmitActions');

var _components2 = require('components');

var _selectors = require('selectors');

var _forms = require('components/RequirementSet/forms');

var _utilityFunctions = require('utils/utilityFunctions');

var _bookingCompanies = require('utils/bookingCompanies');

var _resourcesActions = require('actions/resourcesActions');

var _pacomo = require('utils/pacomo');

var _medicalInformation = require('../utils/mappings/medical-information');

var _links = require('../utils/mappings/links');

var _FormLink = require('../components/forms/FormLink');

var _FormLink2 = _interopRequireDefault(_FormLink);

var _utils = require('../utils/mappings/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onSubmit = (0, _reduxFormSubmitActions.onSubmitUpdateActions)(_resourcesActions.RESOURCES_UPDATE_REQUESTED, _resourcesActions.RESOURCES_UPDATE_SUCCEEDED, _resourcesActions.RESOURCES_UPDATE_FAILED);

var SetCompleteNotice = function SetCompleteNotice() {
    return _react2.default.createElement(
        'div',
        { className: 'alert alert-success', role: 'alert' },
        _react2.default.createElement(
            'strong',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formMessages.congratulations' })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formMessages.reqSetComplete' })
        )
    );
};
SetCompleteNotice = (0, _pacomo.pacomoTransformer)(SetCompleteNotice);

var RequirementSet = function RequirementSet(props) {
    var checkinCall = props.checkinCall,
        customerCall = props.customerCall,
        departureServiceCall = props.departureServiceCall,
        requirementCall = props.requirementCall,
        primaryCustomerCall = props.primaryCustomerCall,
        primaryCustomer = props.primaryCustomer,
        booking = props.booking,
        language = props.language,
        checkinUrlsByCustomerId = props.checkinUrlsByCustomerId,
        customersById = props.customersById,
        departureServicesById = props.departureServicesById,
        profilesByCustomerId = props.profilesByCustomerId,
        isLoadingRequirements = props.isLoadingRequirements,
        requirementSetsByPassenger = props.requirementSetsByPassenger,
        currentUser = props.currentUser,
        params = props.params;


    if (isLoadingRequirements) {
        return _react2.default.createElement(_components2.LoadingIndicator, { apiCalls: [requirementCall] });
    } else {
        var bookingId = booking.id;
        var paxId = params.passengerId;
        var isUserPax = currentUser === paxId;
        var reqSetCode = params.requirementSet;
        var reqSet = requirementSetsByPassenger[paxId].reqSetsByCode[reqSetCode];
        var flightReqSets = (0, _utilityFunctions.getFlightReqSets)(requirementSetsByPassenger);

        var initialValues = reqSet.initialValues;
        var hiddenValues = reqSet.hiddenValues;
        var defaultFormProps = {
            requirementsByCode: reqSet.reqsByCode,
            bookingId: bookingId,
            initialValues: initialValues,
            hiddenValues: hiddenValues,
            isFetchingRequirementData: requirementCall.isFetching,
            onSubmit: onSubmit(initialValues) // initalValues will change after every successfull submit
        };

        var reasonTexts = void 0;
        var reqSetForm = void 0;

        var hideLockedNotice = false;

        var bookingCompany = void 0;
        if (_bookingCompanies.bookingCompanies[booking.booking_company.id]) {
            bookingCompany = _bookingCompanies.bookingCompanies[booking.booking_company.id];
        } else {
            bookingCompany = _bookingCompanies.bookingCompanies[1];
        }
        var isPrimaryCustomerLoading = primaryCustomerCall.isFetching;
        var countryCode = (0, _utils.getCountryCodeFromCustomerData)(primaryCustomer);

        switch (reqSetCode) {
            case 'ACKNOWLEDGEMENTS':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formAcknowledgements.reasonText',
                        defaultMessage: 'Sometimes change happens. And sometimes things are just a little bit\n                                         out of the ordinary. By reviewing this information, we help you make\n                                         sure there are no surprises coming your way.' })];
                    reqSetForm = _react2.default.createElement(
                        _components2.LoadingIndicator,
                        { inline: true, apiCalls: [departureServiceCall] },
                        _react2.default.createElement(_forms.Acknowledgements, (0, _extends3.default)({}, defaultFormProps, {
                            departureServicesById: departureServicesById }))
                    );
                    break;
                }
            case 'CONTACT_INFORMATION':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formContactInformation.reasonText',
                        defaultMessage: 'This information helps us stay in touch in case of any emergencies or\n                                         last-minute changes throughout your trip.' })];
                    reqSetForm = _react2.default.createElement(_forms.ContactInformation, (0, _extends3.default)({}, defaultFormProps, {
                        paxProfile: profilesByCustomerId[paxId] }));
                    break;
                }
            case 'EMERGENCY_CONTACT_INFORMATION':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formEmergencyContactInformation.reasonText',
                        defaultMessage: 'Let us know who to get in touch with.' })];
                    reqSetForm = _react2.default.createElement(_forms.EmergencyContactInformation, defaultFormProps);
                    break;
                }
            case 'INSURANCE_INFORMATION':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formInsuranceInformation.reasonText',
                        defaultMessage: 'We go to some pretty unique destinations on our tours. We want to be sure all\n                                         your insurance details are sorted out ahead of time so we\u2019re prepared for\n                                         anything. Plus, if you forget to bring this information with you, we\u2019ll have it\n                                         right on hand.' })];
                    reqSetForm = _react2.default.createElement(_forms.InsuranceInformation, (0, _extends3.default)({}, defaultFormProps, {
                        isPrimaryCustomerLoading: isPrimaryCustomerLoading,
                        countryCode: countryCode,
                        bookingCompanyId: bookingCompany.id }));
                    break;
                }
            case 'FLIGHT_INFORMATION':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formFlightInformation.reasonText',
                        defaultMessage: 'This information not only lets us know when you\u2019ll be arriving, but it also\n                                         helps us ensure your trips to and from your tour go as smoothly as possible.' })];
                    reqSetForm = _react2.default.createElement(
                        _components2.LoadingIndicator,
                        { inline: true, apiCalls: [departureServiceCall] },
                        _react2.default.createElement(_forms.FlightInformation, (0, _extends3.default)({}, defaultFormProps, {
                            departureServicesById: departureServicesById,
                            paxProfile: profilesByCustomerId[paxId],
                            paxId: paxId,
                            flightReqSets: flightReqSets,
                            bookingCompany: bookingCompany
                        }))
                    );
                    break;
                }
            case 'PARTICIPATION_WAIVER':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formParticipationWaiver.reasonText',
                        defaultMessage: 'The following waiver makes sure you know what to expect from your tour.' })];
                    reqSetForm = _react2.default.createElement(
                        _components2.LoadingIndicator,
                        { inline: true, apiCalls: [customerCall, checkinCall, departureServiceCall] },
                        _react2.default.createElement(_forms.Waiver, (0, _extends3.default)({}, defaultFormProps, {
                            departureServicesById: departureServicesById,
                            isWaiverPax: isUserPax,
                            checkinUrl: checkinUrlsByCustomerId[paxId],
                            waiverPassenger: customersById[paxId],
                            waiverTypes: ['PARTICIPATION_WAIVER'],
                            bookingCompany: bookingCompany }))
                    );
                    hideLockedNotice = true;
                    break;
                }
            case 'LIABILITY_WAIVER':
                {
                    // reasonTexts = [(
                    //     <FormattedMessage id="formParticipationWaiver.reasonText" />
                    // )]
                    reqSetForm = _react2.default.createElement(
                        _components2.LoadingIndicator,
                        { inline: true, apiCalls: [customerCall, checkinCall, departureServiceCall] },
                        _react2.default.createElement(_forms.Waiver, (0, _extends3.default)({}, defaultFormProps, {
                            departureServicesById: departureServicesById,
                            isWaiverPax: isUserPax,
                            checkinUrl: checkinUrlsByCustomerId[paxId],
                            waiverPassenger: customersById[paxId],
                            waiverTypes: ['LIABILITY_WAIVER', 'LIABILITY_WAIVER_KAYAKING', 'LIABILITY_WAIVER_CAMPING'] }))
                    );
                    hideLockedNotice = true;
                    break;
                }
            case 'MEDICAL_INFORMATION':
                {
                    var medicalReasons = _medicalInformation.MEDICAL_REASON_MAP[language][bookingCompany.id] || [];
                    if (isPrimaryCustomerLoading) reasonTexts = [].concat((0, _toConsumableArray3.default)(medicalReasons.map(function (reason) {
                        return reason;
                    })));else {
                        var bookingConditionLink = (0, _utils.getLink)(bookingCompany.id, _links.BOOKING_CONDITIONS_LINK_MAP, countryCode);
                        reasonTexts = [].concat((0, _toConsumableArray3.default)(medicalReasons.map(function (reason) {
                            return reason;
                        })), [bookingConditionLink && _react2.default.createElement(
                            _FormLink2.default,
                            { link: bookingConditionLink },
                            'Booking Conditions'
                        )]);
                    }

                    reqSetForm = _react2.default.createElement(
                        _components2.LoadingIndicator,
                        { inline: true, apiCalls: [customerCall, checkinCall] },
                        _react2.default.createElement(_forms.MedicalInformation, (0, _extends3.default)({}, defaultFormProps, {
                            bookingCompanyId: bookingCompany.id,
                            isMedicalInfoPax: isUserPax,
                            checkinUrl: checkinUrlsByCustomerId[paxId],
                            medicalInfoPax: customersById[paxId] }))
                    );
                    hideLockedNotice = true;
                    break;
                }
            case 'TRAVEL_READY':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formTravelReady.reasonText',
                        defaultMessage: 'You acknowledge that you are responsible for ensuring that you meet all applicable entry\n                        conditions in effect at the time of travel, including with respect to passport and VISA\'s\n                        requirements, along with vaccine and health recommendations from your local health officials.\n                        Information can be found on your country\u2019s foreign travel advice website'
                    })];
                    reqSetForm = _react2.default.createElement(
                        _components2.LoadingIndicator,
                        { inline: true, apiCalls: [customerCall, checkinCall] },
                        _react2.default.createElement(_forms.TravelReady, (0, _extends3.default)({}, defaultFormProps, {
                            bookingCompany: bookingCompany,
                            language: language,
                            isPrimaryCustomerLoading: isPrimaryCustomerLoading,
                            countryCode: countryCode,
                            departureServicesById: departureServicesById }))
                    );
                    hideLockedNotice = true;
                    break;
                }
            case 'PASSPORT_INFORMATION':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formPassportDetails.reasonText',
                        defaultMessage: 'Your passport details are required by most airlines and permits in order\n                                         to issue your items.' })];
                    reqSetForm = _react2.default.createElement(_forms.PassportInformation, defaultFormProps);
                    break;
                }
            case 'PERSONAL_INFORMATION':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formPersonalInformation.reasonText',
                        defaultMessage: 'This helps us make sure your adventure is tailored just for you.' })];
                    reqSetForm = _react2.default.createElement(_forms.PersonalInformation, defaultFormProps);
                    break;
                }
            case 'ROOMING_INFORMATION':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formRoomingInformation.reasonText',
                        defaultMessage: 'Please select who you would prefer to be roomed with.\n                                        If you do not see the name of the person you wish to room with,\n                                        please contact us.'
                    })];
                    reqSetForm = _react2.default.createElement(_forms.RoomingInformation, (0, _extends3.default)({}, defaultFormProps, {
                        departureServicesById: departureServicesById,
                        paxId: paxId,
                        bookingCompanyId: bookingCompany.id
                    }));
                    break;
                }
            case 'TRANSFER_INFORMATION':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formTransferInformation.reasonText',
                        defaultMessage: 'When you travel, sometimes there\u2019s more to think about than just your\n                                         upcoming adventure. This information helps us know where you\u2019re located\n                                         before you travel with us, and how you\u2019re getting to your tour.' })];
                    reqSetForm = _react2.default.createElement(_forms.TransferInformation, defaultFormProps);
                    break;
                }
            case 'TRAVEL_DOCUMENTS':
                {
                    reasonTexts = [_react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formTravelDocuments.reasonText',
                        defaultMessage: 'Sometimes locations will ask visitors for a few additional details\n                                         ahead of time.' })];
                    reqSetForm = _react2.default.createElement(_forms.TravelDocuments, defaultFormProps);
                    break;
                }
            default:
                {
                    reqSetForm = _react2.default.createElement(
                        'div',
                        { className: 'alert alert-danger', role: 'alert' },
                        _react2.default.createElement(
                            'p',
                            { className: 'text-xs-center' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formMessage.formNotFound',
                                defaultMessage: 'Could not find desired form.' })
                        )
                    );
                }
        }

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: 'column reqSet' },
                _react2.default.createElement(_components2.CheckinDocuments, {
                    requirementSets: requirementSetsByPassenger[paxId].reqSets,
                    passengerId: paxId,
                    reqSetCode: reqSetCode }),
                _react2.default.createElement(_components2.FormTitle, {
                    dueDate: reqSet.complete_by_date,
                    requirementSet: reqSet }),
                _react2.default.createElement(_components2.RequirementNav, {
                    passengerId: paxId,
                    reqSetCode: reqSetCode,
                    requirementSets: requirementSetsByPassenger[paxId].reqSets
                }),
                reasonTexts && _react2.default.createElement(_components2.FormReasonText, { reasonTexts: reasonTexts }),
                reqSet.isComplete && _react2.default.createElement(SetCompleteNotice, null),
                _react2.default.createElement(_components2.FormLockedField, { requirementsByCode: reqSet.reqsByCode, hidePrompt: hideLockedNotice }),
                reqSetForm
            ),
            _react2.default.createElement(
                'div',
                { className: 'column' },
                _react2.default.createElement(_components2.NavMarkers, {
                    reqSetCode: reqSetCode,
                    passengerId: paxId,
                    requirementSets: requirementSetsByPassenger[paxId].reqSets
                })
            ),
            _react2.default.createElement(_components2.NavModal, null)
        );
    }
};

RequirementSet.propTypes = {
    checkinCall: _propTypes2.default.object.isRequired,
    customerCall: _propTypes2.default.object.isRequired,
    departureServiceCall: _propTypes2.default.object.isRequired,
    profileCall: _propTypes2.default.object.isRequired,
    requirementCall: _propTypes2.default.object.isRequired,
    primaryCustomerCall: _propTypes2.default.object.isRequired,
    primaryCustomer: _propTypes2.default.object.isRequired,
    booking: _propTypes2.default.object.isRequired,
    language: _propTypes2.default.string.isRequired,
    checkinUrlsByCustomerId: _propTypes2.default.object.isRequired,
    customersById: _propTypes2.default.object.isRequired,
    departureServicesById: _propTypes2.default.object.isRequired,
    profilesByCustomerId: _propTypes2.default.object.isRequired,
    isLoadingRequirements: _propTypes2.default.bool.isRequired,
    requirementSetsByPassenger: _propTypes2.default.object.isRequired,
    currentUser: _propTypes2.default.string.isRequired,
    params: _propTypes2.default.object.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        checkinCall: state.apiCalls.checkinData,
        customerCall: state.apiCalls.customersData,
        departureServiceCall: state.apiCalls.departureServicesData,
        profileCall: state.apiCalls.profilesData,
        requirementCall: state.apiCalls.requirementData,
        primaryCustomerCall: state.apiCalls.primaryCustomerData,
        primaryCustomer: state.primaryCustomer,
        booking: state.booking,
        language: state.intl.locale,
        checkinUrlsByCustomerId: (0, _selectors.getCheckinUrlsByCustomerId)(state),
        customersById: (0, _selectors.getCustomersById)(state),
        departureServicesById: (0, _selectors.getDepartureServicesById)(state),
        profilesByCustomerId: (0, _selectors.getProfilesByCustomerId)(state),
        isLoadingRequirements: !state.apiCalls.requirementData.canLoad,
        requirementSetsByPassenger: (0, _selectors.getRequirementSetsByCustomerId)(state),
        currentUser: '' + state.user.customerId || ''
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _pacomo.pacomoTransformer)(RequirementSet));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/containers/RequirementSet.js
// module id = 1358
// module chunks = 0